<!-- 静音提示 -->
<template>
  <vh-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="true"
    :close-on-press-escape="true"
    :append-to-body="true"
    :show-close="false"
    :dialogCenter="true"
    modalClass="mask-black-55"
    custom-class="muted-tip-dialog"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div class="muted-tip__image"></div>
    <div class="muted-tip__text">{{ $t('player.player_1030') }}</div>
  </vh-dialog>
</template>
<script>
  export default {
    name: 'MutedTip',
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        timer: null
      };
    },
    watch: {
      visible: {
        handler(val) {
          if (val) {
            this.clearTimer();
            this.timer = setTimeout(() => {
              // N秒钟后播放自动关闭
              this.$emit('update:visible', false);
            }, 3000);
          }
        },
        immediate: true
      }
    },
    computed: {
      dialogVisible: {
        get() {
          return this.visible;
        },
        set(val) {
          this.$emit('update:visible', val);
        }
      }
    },
    methods: {
      clearTimer() {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = 0;
        }
      }
    },
    beforeDestroy() {
      this.clearTimer();
    }
  };
</script>
<style lang="less">
  .muted-tip-dialog {
    background-color: transparent;
    box-shadow: none;
    width: auto;

    .vh-dialog__body {
      display: flex;
      flex-direction: column;
      align-items: center;
      .muted-tip__image {
        transform: translateX(30px);
        height: 120px;
        width: 120px;
        background-image: url('../img/muted_tip.png');
        background-size: contain;
        background-position: center center;
        margin-bottom: 12px;
      }
      .muted-tip__text {
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: #fff;
      }
    }
  }
</style>
